import {Component, input, output} from '@angular/core';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatOption, MatSelect} from '@angular/material/select';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {debounceTime} from 'rxjs';

interface SelectOption {
  value: string;
  label: string;
}

@Component({
    selector: 'tgrid-single-select-filter',
    imports: [
        MatFormField,
        MatSelect,
        MatOption,
        ReactiveFormsModule,
        MatLabel,
    ],
    templateUrl: './single-select-filter.component.html',
    standalone: true,
    styleUrl: './single-select-filter.component.scss',
})


export class SingleSelectFilterComponent {
  private o = [
    {label: 'Investor Owned', value: 'INVESTOR OWNED'},
    {label: 'Community Choice Aggregator', value: 'COMMUNITY CHOICE AGGREGATOR'},
    {label: 'Wholesale Power Marketer', value: 'WHOLESALE POWER MARKETER'},
    {label: 'Municipal', value: 'MUNICIPAL'},
    {label: 'Municipal Mktg Authority', value: 'MUNICIPAL MKTG AUTHORITY'},
    {label: 'Federal', value: 'FEDERAL'},
    {label: 'Political Subdivision', value: 'POLITICAL SUBDIVISION'},
    {label: 'Cooperative', value: 'COOPERATIVE'},
    {label: 'State', value: 'STATE'},
    {label: 'Not Available', value: 'NOT AVAILABLE'},
  ];

  public options = input<SelectOption[]>(this.o);
  public placeholder = input<string>('Filter');
  public filterChange = output<string>();

  protected filterControl: FormControl = new FormControl(this.o.map(v => v.value));

  constructor() {


    this.filterControl.valueChanges.pipe(
      debounceTime(100),
      takeUntilDestroyed(),
    ).subscribe(newValue => {
      this.filterChange.emit(newValue);
    });
  }


}
